import React from 'react';
import classNames from 'classnames';

import {
  POLL_TYPE_MULTI_SELECT,
  POLL_TYPE_SINGLE_CHOICE,
} from './pollFormValidation';
import css from './CreatePollForm.module.css';

const pollTypeOptions = [
  { value: POLL_TYPE_SINGLE_CHOICE, label: 'Single choice' },
  { value: POLL_TYPE_MULTI_SELECT, label: 'Multi-select' },
];

const PollTypeSelector = props => {
  const { value, onChange, disabled } = props;

  return (
    <div className={css.pollTypeSelector} role="radiogroup" aria-label="Poll type">
      {pollTypeOptions.map(option => {
        const isSelected = value === option.value;

        return (
          <button
            key={option.value}
            type="button"
            className={classNames(css.pollTypeButton, {
              [css.pollTypeButtonSelected]: isSelected,
            })}
            aria-checked={isSelected}
            disabled={disabled}
            role="radio"
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default PollTypeSelector;
